import { RoleEndpoints } from '@/modules/preference/role/api/roleEndpoints'

export const roleEndpoints = new RoleEndpoints()
